import { ValueOf } from 'types';

export const AdminVisibility = {
  DEFAULT: 'DEFAULT',
  OBFUSCATE_SENSITIVE: 'OBFUSCATE_SENSITIVE',
} as const;
export type AdminVisibility = ValueOf<typeof AdminVisibility>;
